const actionsPrefix = 'RETAILER_START_ORDER_MODAL'

export const CHANGE_BRAND_SEARCH_TEXT = `${actionsPrefix}/CHANGE_BRAND_SEARCH_TEXT`
export const SET_BRAND_ID = `${actionsPrefix}/SET_BRAND_ID`
export const CHANGE_COLLECTION_SEARCH_TEXT = `${actionsPrefix}/CHANGE_COLLECTION_SEARCH_TEXT`
